export const recentTxnsData = [
    {
        "objectId": "66bd24d6eb800356926c001e",
        "id": "abc0641c-a369-44e0-a1a3-b1cc0165ca7a",
        "businessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "accountId": "dbff996b-541e-4302-ae41-60f704b3fda0",
        "achId": "5cbcd6dd-e800-4188-956e-b1cc0165840d",
        "amount": 35910.0,
        "amountStr": "35910",
        "balance": 542947.38,
        "balanceStr": "542947.38",
        "bookkeepingCategory": [
            "Income",
            "Income"
        ],
        "category": [
            "Transfer",
            "Credit"
        ],
        "checkId": null,
        "bookId": null,
        "cardId": null,
        "checkNumber": null,
        "billPaymentId": null,
        "instantTransferId": null,
        "date": "2024-08-14",
        "txnDate": "2024-08-14",
        "desc": "CAJUN SPICE CO. INVPMT ACH CCD ID: 9892414 REF: A2277H4720K4",
        "fingerprint": null,
        "logo": "https://s3-us-west-2.amazonaws.com/fundpnb-assets/categories/Special/deposit.png",
        "name": "CAJUN SPICE CO. INVPMT ACH CCD ID: 9892414 REF: A2277H4720K4",
        "summary": null,
        "type": null,
        "typeSource": null,
        "wire": null,
        "wireId": null,
        "displayDescription": "GRAYSTONE INDUSTRIES",
        "checkReference": null,
        "categoryLevel": null,
        "categoryCode": null,
        "splitTransactions": null,
        "paymentId": null,
        "transactionId": "e6687afa-2ab1-4d98-899e-b1cc0165841c",
        "traceNumber": "T24227174240L83DB",
        "isTxnCategorized": null,
        "transactionType": "Credit",
        "activityType": null,
        "source": null,
        "currency": "usd",
        "providerStatus": "Posted",
        "masterAccountNumber": "2922687724",
        "subAccountNumber": "2922687724",
        "transactionCode": "Incoming ACH",
        "rail": "Ach",
        "subRail": null,
        "railId": "payment/5cbcd6dd-e800-4188-956e-b1cc0165840d",
        "flags": [
            "DIR:Inbound",
            "TYP:Origination",
            "CID:9892414",
            "RTN:021000021"
        ],
        "schedule": [],
        "postingDate": "2024-08-14T00:00:00-04:00",
        "executedAt": "2024-08-14T17:42:40.637-04:00",
        "postedAt": "2024-08-15T00:13:22.597-04:00",
        "createdAt": "2024-08-14T17:42:40.653-04:00",
        "lastModifiedAt": "2024-08-14T17:42:40.6518469-04:00",
        "sequenceNumber": 59,
        "merchantName": null,
        "merchantLocation": null,
        "merchantCategory": null,
        "categorized": false,
        "clearing": false,
        "coacategory": null,
        "coatype": null,
        "coaid": null,
        "coaparentCategory": null,
        "coasubType": null
    },
    {
        "objectId": "66b6680025e3bf5450fcae66",
        "id": "3d3f1010-8853-48e1-be82-b1c70139f587",
        "businessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "accountId": "e09c8e7b-659d-4c23-9276-01611e8243dd",
        "achId": "24e1d38e-aee2-4275-a806-b1c70139af0f",
        "amount": 100000.0,
        "amountStr": "100000",
        "balance": 100500.0,
        "balanceStr": "100500",
        "bookkeepingCategory": [
            "Income",
            "Income"
        ],
        "category": [
            "Transfer",
            "Credit"
        ],
        "checkId": null,
        "bookId": null,
        "cardId": null,
        "checkNumber": null,
        "billPaymentId": null,
        "instantTransferId": null,
        "date": "2024-08-14",
        "txnDate": "2024-08-14",
        "desc": "WHOLE FOODS INVPMT ACH CCD ID: 95133 REF: A2227J947M1I",
        "fingerprint": null,
        "logo": "https://s3-us-west-2.amazonaws.com/fundpnb-assets/categories/Special/deposit.png",
        "name": "WHOLE FOODS INVPMT ACH CCD ID: 95133 REF: A2227J947M1I",
        "summary": null,
        "type": null,
        "typeSource": null,
        "wire": null,
        "wireId": null,
        "displayDescription": "SOUTHPORT BRICKWORKS",
        "checkReference": null,
        "categoryLevel": null,
        "categoryCode": null,
        "splitTransactions": null,
        "paymentId": null,
        "transactionId": "981d634f-179b-4402-8302-b1c70139af2b",
        "traceNumber": "T24222150305W44OD",
        "isTxnCategorized": null,
        "transactionType": "Credit",
        "activityType": null,
        "source": null,
        "currency": "usd",
        "providerStatus": "Posted",
        "masterAccountNumber": "2148769421",
        "subAccountNumber": "2148769421",
        "transactionCode": "Incoming ACH",
        "rail": "Ach",
        "subRail": null,
        "railId": "payment/24e1d38e-aee2-4275-a806-b1c70139af0f",
        "flags": [
            "DIR:Inbound",
            "TYP:Origination",
            "CID:95133",
            "RTN:021000021"
        ],
        "schedule": [],
        "postingDate": "2024-08-09T00:00:00-04:00",
        "executedAt": "2024-08-09T15:03:05.427-04:00",
        "postedAt": "2024-08-10T00:14:11.78-04:00",
        "createdAt": "2024-08-09T15:03:05.46-04:00",
        "lastModifiedAt": "2024-08-09T15:03:05.4587904-04:00",
        "sequenceNumber": 12,
        "merchantName": null,
        "merchantLocation": null,
        "merchantCategory": null,
        "categorized": false,
        "clearing": false,
        "coacategory": null,
        "coatype": null,
        "coaid": null,
        "coaparentCategory": null,
        "coasubType": null
    },
    {
        "objectId": "66b6541025e3bf5450fcae4f",
        "id": "c9414f90-28f3-4ad9-ac29-b1c7012290ab",
        "businessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "accountId": "dbff996b-541e-4302-ae41-60f704b3fda0",
        "achId": null,
        "amount": 200000.0,
        "amountStr": "200000",
        "balance": 507037.38,
        "balanceStr": "507037.38",
        "bookkeepingCategory": [
            "Income",
            "Income"
        ],
        "category": [
            "Transfer",
            "Credit"
        ],
        "checkId": null,
        "bookId": null,
        "cardId": null,
        "checkNumber": null,
        "billPaymentId": null,
        "instantTransferId": null,
        "date": "2024-08-13",
        "txnDate": "2024-08-13",
        "desc": "Internal Transfer from 2733073692 to 2922687724",
        "fingerprint": null,
        "logo": "https://s3-us-west-2.amazonaws.com/fundpnb-assets/categories/Special/deposit.png",
        "name": "AION Loan ID AIAR184 | ACME ENTERPRISES, INC.",
        "summary": null,
        "type": null,
        "typeSource": null,
        "wire": null,
        "wireId": null,
        "displayDescription": "AION DRAW AIAR184 | ACME ENTERPRISES, INC.",
        "checkReference": null,
        "categoryLevel": null,
        "categoryCode": null,
        "splitTransactions": null,
        "paymentId": null,
        "transactionId": "21023eca-b9f0-427a-b1f3-b1c7012290ab",
        "traceNumber": "T24222133754F25CS",
        "isTxnCategorized": null,
        "transactionType": "Credit",
        "activityType": null,
        "source": null,
        "currency": "usd",
        "providerStatus": "Posted",
        "masterAccountNumber": "2922687724",
        "subAccountNumber": "2922687724",
        "transactionCode": "Account Transfer",
        "rail": "Internal",
        "subRail": null,
        "railId": "0",
        "flags": [],
        "schedule": [],
        "postingDate": "2024-08-09T00:00:00-04:00",
        "executedAt": "2024-08-09T13:37:54.937-04:00",
        "postedAt": "2024-08-10T00:14:14.02-04:00",
        "createdAt": "2024-08-09T13:37:54.95-04:00",
        "lastModifiedAt": "2024-08-09T13:37:54.9507885-04:00",
        "sequenceNumber": 58,
        "merchantName": null,
        "merchantLocation": null,
        "merchantCategory": null,
        "categorized": false,
        "clearing": false,
        "coacategory": null,
        "coatype": null,
        "coaid": null,
        "coaparentCategory": null,
        "coasubType": null
    },
    {
        "objectId": "66b55f444b4f673904454dd7",
        "id": "1f578bd3-557f-482b-93fb-b1c70003cf8b",
        "businessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "accountId": "dbff996b-541e-4302-ae41-60f704b3fda0",
        "achId": null,
        "amount": -100000.0,
        "amountStr": "-100000",
        "balance": 307052.38,
        "balanceStr": "307052.38",
        "bookkeepingCategory": [
            "Other Expenses",
            "Other Expenses"
        ],
        "category": [
            "Transfer",
            "Wire"
        ],
        "checkId": null,
        "bookId": null,
        "cardId": null,
        "checkNumber": null,
        "billPaymentId": null,
        "instantTransferId": null,
        "date": "2024-08-13",
        "txnDate": "2024-08-13",
        "desc": "Outgoing Wire Misfits Market W2422148940",
        "fingerprint": null,
        "logo": "https://s3-us-west-2.amazonaws.com/fundpnb-assets/categories/Special/payment.png",
        "name": "Outgoing Wire Misfits Market W2422148940 Second Investment",
        "summary": null,
        "type": null,
        "typeSource": null,
        "wire": null,
        "wireId": "77ae8829-d254-446e-9440-b1c70003cf42",
        "displayDescription": "BILL PAY MISFITS MARKET W2422148940",
        "checkReference": null,
        "categoryLevel": null,
        "categoryCode": null,
        "splitTransactions": null,
        "paymentId": null,
        "transactionId": "d6382e7c-1e40-402f-b6a1-b1c70003cf42",
        "traceNumber": "T24221201352LF96I",
        "isTxnCategorized": null,
        "transactionType": "Debit",
        "activityType": null,
        "source": null,
        "currency": "usd",
        "providerStatus": "Posted",
        "masterAccountNumber": "2922687724",
        "subAccountNumber": "2922687724",
        "transactionCode": "Outgoing Wire",
        "rail": "Wires",
        "subRail": null,
        "railId": "payment/77ae8829-d254-446e-9440-b1c70003cf42",
        "flags": [],
        "schedule": [],
        "postingDate": "2024-08-08T00:00:00-04:00",
        "executedAt": "2024-08-08T20:13:52.477-04:00",
        "postedAt": "2024-08-09T00:11:58.533-04:00",
        "createdAt": "2024-08-08T20:13:52.48-04:00",
        "lastModifiedAt": "2024-08-08T20:13:52.4805069-04:00",
        "sequenceNumber": 56,
        "merchantName": null,
        "merchantLocation": null,
        "merchantCategory": null,
        "categorized": false,
        "clearing": false,
        "coacategory": null,
        "coatype": null,
        "coaid": null,
        "coaparentCategory": null,
        "coasubType": null
    },
    {
        "objectId": "66b55c934b4f673904454dbd",
        "id": "b63e6292-aa91-4bf8-ade3-b1c70000892f",
        "businessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "accountId": "dbff996b-541e-4302-ae41-60f704b3fda0",
        "achId": null,
        "amount": -150.0,
        "amountStr": "-75000",
        "balance": 407067.38,
        "balanceStr": "407067.38",
        "bookkeepingCategory": [
            "Other Expenses",
            "Other Expenses"
        ],
        "category": [
            "Transfer",
            "Wire"
        ],
        "checkId": null,
        "bookId": null,
        "cardId": null,
        "checkNumber": null,
        "billPaymentId": null,
        "instantTransferId": null,
        "date": "2024-08-13",
        "txnDate": "2024-08-13",
        "desc": "Outgoing Wire Misfits Market W2422177DS6",
        "fingerprint": null,
        "logo": "https://s3-us-west-2.amazonaws.com/fundpnb-assets/categories/Special/payment.png",
        "name": "Outgoing Wire Misfits Market W2422177DS6 Investment 1",
        "summary": null,
        "type": null,
        "typeSource": null,
        "wire": null,
        "wireId": "df3f356d-ea57-4688-a98f-b1c700008904",
        "displayDescription": "DOORDASH TEAM LUNCH",
        "checkReference": null,
        "categoryLevel": null,
        "categoryCode": null,
        "splitTransactions": null,
        "paymentId": null,
        "transactionId": "c9b52195-b3ed-458b-8f9f-b1c700008904",
        "traceNumber": "T24221200157E3WM3",
        "isTxnCategorized": null,
        "transactionType": "Debit",
        "activityType": null,
        "source": null,
        "currency": "usd",
        "providerStatus": "Posted",
        "masterAccountNumber": "2922687724",
        "subAccountNumber": "2922687724",
        "transactionCode": "Outgoing Wire",
        "rail": "Wires",
        "subRail": null,
        "railId": "payment/df3f356d-ea57-4688-a98f-b1c700008904",
        "flags": [],
        "schedule": [],
        "postingDate": "2024-08-08T00:00:00-04:00",
        "executedAt": "2024-08-08T20:01:57.08-04:00",
        "postedAt": "2024-08-09T00:11:58.533-04:00",
        "createdAt": "2024-08-08T20:01:57.093-04:00",
        "lastModifiedAt": "2024-08-08T20:01:57.0939083-04:00",
        "sequenceNumber": 54,
        "merchantName": null,
        "merchantLocation": null,
        "merchantCategory": null,
        "categorized": false,
        "clearing": false,
        "coacategory": null,
        "coatype": null,
        "coaid": null,
        "coaparentCategory": null,
        "coasubType": null
    }
]

export const billInboxData = [
    {
        "id": "1",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "from": "Deepesh Sunku <dsunku@aionfi.com>",
        "to": "ragnar@staging-bills.aionfi.com",
        "sender": "dsunku@aionfi.com",
        "recipient": "ragnar@staging-bills.aionfi.com",
        "subject": "Fwd: NEW INVOICES",
        "sentDate": "Thu, 18 Jul 2024 10:29:52 -0700",
        "attachmentUrl": {
            "fileName": "INVOICEDOC_145.pdf",
            "bucketName": null,
            "type": "application/pdf",
            "objectType": null,
            "notes": null,
            "mimeType": null,
            "uri": "https://fpb-business-documents.s3.us-west-1.amazonaws.com/AIONTEST489/billinbox/AKDFPR-INVOICEDOC_145.pdf"
        },
        "parseJobId": null,
        "parsedInvoiceId": "669951250a88a2439870ea6d",
        "invoiceAmount": 6000,
        "vendorName": "Amazon Web Services",
        "invoiceDueDate": "2021-02-21T00:00:00.000+00:00",
        "billId": null,
        "billNumber": null,
        "processingErrorMessage": null,
        "createdDate": "2024-07-18T17:30:07.250+00:00",
        "converted": false,
        "archived": false,
        "processingError": false
    },
    {
        "id": "2",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "from": "Deepesh Sunku <dsunku@aionfi.com>",
        "to": "ragnar@staging-bills.aionfi.com",
        "sender": "dsunku@aionfi.com",
        "recipient": "ragnar@staging-bills.aionfi.com",
        "subject": "Fwd: NEW INVOICES",
        "attachmentUrl": {
            "fileName": "INVOICEDOC_168.pdf",
            "bucketName": null,
            "type": "application/pdf",
            "objectType": null,
            "notes": null,
            "mimeType": null,
            "uri": "https://fpb-business-documents.s3.us-west-1.amazonaws.com/AIONTEST489/billinbox/mp49PT-INVOICEDOC_168.pdf"
        },
        "parseJobId": null,
        "parsedInvoiceId": "669951410a88a2439870ea71",
        "invoiceAmount": 2000,
        "vendorName": "Orange Inc",
        "invoiceDueDate": "2021-04-20T00:00:00.000+00:00",
        "billId": null,
        "billNumber": null,
        "processingErrorMessage": null,
        "createdDate": "2024-07-18T17:30:07.250+00:00",
        "converted": false,
        "archived": false,
        "processingError": false
    },
    {
        "id": "3",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "from": "Deepesh Sunku <dsunku@aionfi.com>",
        "to": "ragnar@staging-bills.aionfi.com",
        "sender": "dsunku@aionfi.com",
        "recipient": "ragnar@staging-bills.aionfi.com",
        "subject": "Fwd: NEW INVOICES",
        "sentDate": "Thu, 18 Jul 2024 10:29:52 -0700",
        "attachmentUrl": {
            "fileName": "INVOICEDOC_2384.pdf",
            "bucketName": null,
            "type": "application/pdf",
            "objectType": null,
            "notes": null,
            "mimeType": null,
            "uri": "https://fpb-business-documents.s3.us-west-1.amazonaws.com/AIONTEST489/billinbox/3ek2Ti-INVOICEDOC_2384.pdf"
        },
        "parseJobId": null,
        "parsedInvoiceId": "6699515d0a88a2439870ea73",
        "invoiceAmount": 3100,
        "vendorName": "Global Dynamics",
        "invoiceDueDate": "2020-12-19T00:00:00.000+00:00",
        "billId": null,
        "billNumber": null,
        "processingErrorMessage": null,
        "createdDate": "2024-07-18T17:30:07.250+00:00",
        "converted": false,
        "archived": false,
        "processingError": false
    },
    {
        "id": "4",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "from": "Deepesh Sunku <dsunku@aionfi.com>",
        "to": "ragnar@staging-bills.aionfi.com",
        "sender": "dsunku@aionfi.com",
        "recipient": "ragnar@staging-bills.aionfi.com",
        "subject": "Fwd: NEW INVOICES",
        "sentDate": "Thu, 18 Jul 2024 10:29:52 -0700",
        "attachmentUrl": {
            "fileName": "INVOICEDOC_2384.pdf",
            "bucketName": null,
            "type": "application/pdf",
            "objectType": null,
            "notes": null,
            "mimeType": null,
            "uri": "https://fpb-business-documents.s3.us-west-1.amazonaws.com/AIONTEST489/billinbox/3ek2Ti-INVOICEDOC_2384.pdf"
        },
        "parseJobId": null,
        "parsedInvoiceId": "6699515d0a88a2439870ea73",
        "invoiceAmount": 3000,
        "vendorName": "Hooli Consulting",
        "invoiceDueDate": "2020-12-19T00:00:00.000+00:00",
        "billId": null,
        "billNumber": null,
        "processingErrorMessage": null,
        "createdDate": "2024-07-18T17:30:07.250+00:00",
        "converted": false,
        "archived": false,
        "processingError": false
    },
    {
        "id": "5",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "from": "Deepesh Sunku <dsunku@aionfi.com>",
        "to": "ragnar@staging-bills.aionfi.com",
        "sender": "dsunku@aionfi.com",
        "recipient": "ragnar@staging-bills.aionfi.com",
        "subject": "Fwd: NEW INVOICES",
        "sentDate": "Thu, 18 Jul 2024 10:29:52 -0700",
        "attachmentUrl": {
            "fileName": "INVOICEDOC_2384.pdf",
            "bucketName": null,
            "type": "application/pdf",
            "objectType": null,
            "notes": null,
            "mimeType": null,
            "uri": "https://fpb-business-documents.s3.us-west-1.amazonaws.com/AIONTEST489/billinbox/3ek2Ti-INVOICEDOC_2384.pdf"
        },
        "parseJobId": null,
        "parsedInvoiceId": "6699515d0a88a2439870ea73",
        "invoiceAmount": 1300,
        "vendorName": "Curtis Advertising",
        "invoiceDueDate": "2020-12-19T00:00:00.000+00:00",
        "billId": null,
        "billNumber": null,
        "processingErrorMessage": null,
        "createdDate": "2024-07-18T17:30:07.250+00:00",
        "converted": false,
        "archived": false,
        "processingError": false
    }
]

export const approvalsInbox = [
    {
        "inboxId": "1",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "firstName": "Ragnar",
        "lastName": "Lothbrok",
        "userName": "engr0320211@aionfi.com",
        "currentRank": 0,
        "currentLevel": 1,
        "ruleInstanceId": "66ce07695452ad0e5b89483d",
        "objectId": "66ce07695452ad0e5b89483c",
        "objectType": "ACH",
        "performedAction": null,
        "status": "Pending",
        "performerNotes": null,
        "assignedTime": "2024-08-27T17:05:45.780+00:00",
        "actionTime": null,
        "contextIdentifier": "Bill Payment to Pied Piper",
        "initiatedBy": "Ragnar Lothbrok",
        "sourceApplication": "Payables"
    },
    {
        "inboxId": "2",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "firstName": "Ragnar",
        "lastName": "Lothbrok",
        "userName": "engr0320211@aionfi.com",
        "currentRank": 0,
        "currentLevel": 1,
        "ruleInstanceId": "66ce07315452ad0e5b89483a",
        "objectId": "66ce07315452ad0e5b894839",
        "objectType": "ACH",
        "performedAction": null,
        "status": "Pending",
        "performerNotes": null,
        "assignedTime": "2024-08-27T17:04:49.283+00:00",
        "actionTime": null,
        "contextIdentifier": "Very Good Payroll Inc.",
        "initiatedBy": "Ragnar Lothbrok",
        "sourceApplication": "Banking"
    },
    {
        "inboxId": "3",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "firstName": "Ragnar",
        "lastName": "Lothbrok",
        "userName": "engr0320211@aionfi.com",
        "currentRank": 0,
        "currentLevel": 1,
        "ruleInstanceId": "66ce07315452ad0e5b89483a",
        "objectId": "66ce07315452ad0e5b894839",
        "objectType": "ACH",
        "performedAction": null,
        "status": "Pending",
        "performerNotes": null,
        "assignedTime": "2024-08-27T17:04:49.283+00:00",
        "actionTime": null,
        "contextIdentifier": "Bill Payment Amazon Web Wervices",
        "initiatedBy": "Ragnar Lothbrok",
        "sourceApplication": "Payables"
    },
    {
        "inboxId": "4",
        "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
        "firstName": "Ragnar",
        "lastName": "Lothbrok",
        "userName": "engr0320211@aionfi.com",
        "currentRank": 0,
        "currentLevel": 1,
        "ruleInstanceId": "66ce07315452ad0e5b89483a",
        "objectId": "66ce07315452ad0e5b894839",
        "objectType": "ACH",
        "performedAction": null,
        "status": "Pending",
        "performerNotes": null,
        "assignedTime": "2024-08-27T17:04:49.283+00:00",
        "actionTime": null,
        "contextIdentifier": "Bill Payment - Very Good Security: 12580",
        "initiatedBy": "Ragnar Lothbrok",
        "sourceApplication": "Payables"
    }
]

export const creditAvailableFunds = {
    "Borrower": "ACME ENTERPRISES, INC.",
    "AccountNumber": "AIONTEST4933",
    "LoanType": "AR",
    "BorrowerAdvanceLimit": 800000,
    "BorrowerAdvanceTaken": 200000,
    "BorrowerAdvanceLeft": 600000,
    "GrossInventory": 0,
    "IneligibleInventory": 0,
    "EligibleInventory": 0,
    "InventoryAdvanceRate": 0.3,
    "HardCapInventoryLimit": 200000,
    "InventoryCap": 0.4,
    "GrossAdvanceableEligibleInventory": 0,
    "GrossAdvanceableHardCapInventoryLimit": 200000,
    "GrossAdvanceableInventoryCap": 213532.71,
    "GrossAdvanceableInventory": 0,
    "ARAdvanceRate": 0.85,
    "GrossAssets": 1080616.63,
    "GrossAR": 1080616.63,
    "IneligibleInvoices": 452579.25,
    "AggregatePayments": 0,
    "EligibleAR": 628037.38,
    "EligibleARExcludingPayments": 628037.38,
    "GrossAdvanceableAR": 533831.77,
    "GrossAdvanceableAssets": 533831.77,
    "Adjustments": 0,
    "NetAdvanceableAssets": 533831.77,
    "OutstandingBalanceToNetAdvanceableAssets": 0.37,
    "UploadInventoryJobId": "job_e3d792f6-2dd2-4168-bc07-2d895ffc88b5",
    "UploadInventoryDate": "2024-06-18T02:54:51.947Z",
    "InventoryObjectId": "6670f6fbc179275835fc11c3",
    "PaymentReference": [],
    "PaymentsReconedFrom": "1800-01-01T00:00:00.000Z",
    "PaymentsReconedTo": "2024-08-28T18:28:46.788Z",
    "OverAdvanced": false,
    "InventoryUploadDue": null,
    "FreezeCreditLine": false,
    "OverAdvancedAmount": 0,
    "AvailableFunds": 333831.77,
    "OutstandingGrossCollateral": 1080616.63,
    "OutstandingEligibleCollateral": 628037.38,
    "DrawFeesToBorrower": false
}

export const creditARAdvances = {
    "ARAdvances": [{
        "_id": "66b652490becad001b6d1d5d",
        "Id": "AIAR184",
        "BusinessId": "1191fcee-e6f1-47d2-9cb6-be248795ce4c",
        "LoanId": "AIAR184",
        "LoanNumber": "AIAR184",
        "AdvanceAmount": 200000,
        "AdvanceDate": "2024-08-09T17:30:49.756Z",
        "ProductType": "StandardFunding",
        "LoanType": "AB",
        "LoanStatus": "Deposited",
        "AdvanceDueDate": "2024-10-08T17:30:49.756Z",
        "Rate": 0.015,
        "DepositedDate": "2024-08-09T17:37:55.776Z",
        "RepayInfo": {},
        "RepaidInfo": [],
        "AdvancePaid": null,
        "Balance": 200000,
        "AdvanceClearedDate": null,
        "AdvanceNotes": "Working capital",
        "FeePercentage": null,
        "IfFeeRecipientExists": false,
        "FeeRecipient": "",
        "FlatFee": null,
        "FeeType": "",
        "FeeRecipientId": "",
        "Fees": null,
        "FirstName": "Jonathan",
        "LastName": "Coleman",
        "UserEmail": "demo.jcoleman@mg.aionfi.com",
        "FeesApplied": null
    }],
    "ARAdvanceInfo": {
        "AdvanceLimit": 800000,
        "CreditLimit": 0,
        "Fees": 1.5,
        "RepaymentDays": 90,
        "CreditTaken": 200000,
        "CreditLeft": 600000,
        "CreditTakenHistory": 0,
        "Repaid": 0,
        "RepaidHistory": 0,
        "CreditTakenToDate": 400000
    }
}

export const extAccounts = {
    "responseMessage": null,
    "additionalContext": null,
    "additionalInfo": null,
    "count": 0,
    "numPages": 0,
    "pageNumber": 1,
    "pageable": false,
    "extBBInstitutions": [
        {
            "objectId": "67216e96e8d34d0cd1c335ed",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "integrationProvider": "Plaid",
            "institutionId": "ins_5",
            "bankName": "Citibank Online",
            "websiteUrl": "https://www.citi.com",
            "accessToken": "access-sandbox-1c0f2298-796e-4499-8d37-d318513b22ab",
            "logoUrl": "https://ext-bank-logos.s3-us-west-1.amazonaws.com/plaid/ins_5.png",
            "publicToken": "public-sandbox-059e1ef0-0c14-4b99-88d9-91e21281b3c5",
            "itemId": "j4l3g5D3ydiqrmq7VpX8Hw81VMg36wF1G5Mrk",
            "nextCursor": "CAESJVhBNXB3R0xwN01pQjZkQjdYNDFaVFg5Vzl3QWdCTENiS3pvWHkaDAjT1eq5BhCYtePrAiIMCNPV6rkGEJi14+sCKgwI09XquQYQmLXj6wI=",
            "initiatedBy": "engr0320211@aionfi.com",
            "providerAccountId": null,
            "providerId": null,
            "status": "Connected",
            "syncStatus": "Transactions Synced",
            "lastDisconnectedDate": null,
            "createdAt": "2024-10-29T23:24:06.743+00:00",
            "lastUpdatedAt": "2024-11-18T02:47:52.671+00:00",
            "syncTransactionsProcessing": false,
            "historicalUpdateCompleted": true,
            "statementGenerated": null,
            "accountMask": null
        },
        {
            "objectId": "6736972748a6f036c76d2221",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "integrationProvider": "Plaid",
            "institutionId": "ins_10",
            "bankName": "American Express",
            "websiteUrl": "https://www.americanexpress.com/",
            "accessToken": "access-sandbox-89e85e09-0c50-40d9-8c33-32711598866a",
            "logoUrl": "https://ext-bank-logos.s3-us-west-1.amazonaws.com/plaid/ins_10.png",
            "publicToken": "public-sandbox-faf72e37-351b-4af2-bc6d-9e404317a83b",
            "itemId": "BAPMJR54R1UZjzLlZnVMcplRypgQxPtwAarNo",
            "nextCursor": "CAESJUs2a0tKblYxbkdDa3FqcFBrZ1JuRjk4TkpsNXdMOGlSa2o3TWQaDAimreq5BhCopvD0ASIMCKat6rkGEKim8PQBKgwIpq3quQYQqKbw9AE=",
            "initiatedBy": "engr0320211@aionfi.com",
            "providerAccountId": null,
            "providerId": null,
            "status": "Connected",
            "syncStatus": "Transactions Synced",
            "lastDisconnectedDate": null,
            "createdAt": "2024-11-15T00:34:47.747+00:00",
            "lastUpdatedAt": "2024-11-18T01:21:47.821+00:00",
            "syncTransactionsProcessing": false,
            "historicalUpdateCompleted": true,
            "statementGenerated": null,
            "accountMask": null
        },
        {
            "objectId": "673fdb4211203f45d7e72b3d",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "integrationProvider": "Plaid",
            "institutionId": "ins_56",
            "bankName": "Chase",
            "websiteUrl": "https://www.chase.com",
            "accessToken": "access-sandbox-bc61d04a-2a93-4f14-9b4d-f2e47e6fb9d3",
            "logoUrl": "https://ext-bank-logos.s3-us-west-1.amazonaws.com/plaid/ins_56.png",
            "publicToken": "public-sandbox-be0576d5-f2e4-4401-8469-7a86eb6e1b1c",
            "itemId": "eok4BpA4ootJlgr9Pel3fZe9xrzBRKtLrqpyQ",
            "nextCursor": "CAESJU5HeFZaRXpWR0dVeEVqZTR6UUVCRndXZ0p4V3k4YWZ5cEVuUksaDAjHtv+5BhD4sMScAyIMCMe2/7kGEPiwxJwDKgwIx7b/uQYQ+LDEnAM=",
            "initiatedBy": "engr0320211@aionfi.com",
            "providerAccountId": null,
            "providerId": null,
            "status": "Connected",
            "syncStatus": "Transactions Synced",
            "lastDisconnectedDate": null,
            "createdAt": "2024-11-22T01:15:46.759+00:00",
            "lastUpdatedAt": "2024-11-22T01:16:16.420+00:00",
            "syncTransactionsProcessing": false,
            "historicalUpdateCompleted": true,
            "statementGenerated": null,
            "accountMask": null
        },
        {
            "objectId": "6740df61a3d5df6606aa7a9d",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "integrationProvider": "Plaid",
            "institutionId": "ins_127991",
            "bankName": "Wells Fargo",
            "websiteUrl": "https://www.wellsfargo.com",
            "accessToken": "access-sandbox-7e0dae8c-71c5-43e8-89b0-e2ba8fd3c29b",
            "logoUrl": "https://ext-bank-logos.s3-us-west-1.amazonaws.com/plaid/ins_127991.png",
            "publicToken": "public-sandbox-e9a0ca89-c1a2-435d-88dc-02d008ec459a",
            "itemId": "jG4DnE1dMxCW5QaRXgqriDGNrNDKwbu1lR118",
            "nextCursor": "",
            "initiatedBy": "engr0320211@aionfi.com",
            "providerAccountId": null,
            "providerId": null,
            "status": "Connected",
            "syncStatus": "Transactions Synced",
            "lastDisconnectedDate": null,
            "createdAt": "2024-11-22T19:45:37.044+00:00",
            "lastUpdatedAt": "2024-11-22T19:45:45.182+00:00",
            "syncTransactionsProcessing": false,
            "historicalUpdateCompleted": true,
            "statementGenerated": null,
            "accountMask": null
        }
    ],
    "extBBAccounts": [
        {
            "id": "67216e97e8d34d0cd1c335ee",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "itemId": "j4l3g5D3ydiqrmq7VpX8Hw81VMg36wF1G5Mrk",
            "institutionId": "ins_5",
            "bankProvider": "Citibank Online",
            "integrationProvider": "Plaid",
            "providerAccountId": null,
            "providerId": null,
            "accountId": "K75wVdxwqBiMbLMqPQ4lhlnNkXovzxiR1wnje",
            "mask": "0000",
            "accountName": null,
            "nickName": null,
            "accountType": "depository",
            "accountSubType": "checking",
            "accountNumber": "1111222233330000",
            "routingNumber": "011401533",
            "title": "Checking",
            "officialTitle": "Gold Standard 0% Interest Checking",
            "status": null,
            "address": null,
            "availableBalance": 100.0,
            "currentBalance": 110.0,
            "currency": "USD",
            "achAccounts": {
                "account": null,
                "accountId": null,
                "routing": null,
                "wireRouting": null
            },
            "bacAccounts": null,
            "eftAccounts": null,
            "createdAt": "2024-10-29T23:24:10.221+00:00",
            "lastUpdatedAt": "2024-11-18T02:47:50.993+00:00",
            "dailyBalances": [
                {
                    "name": "10/29/2024",
                    "value": 100.0
                },
                {
                    "name": "10/30/2024",
                    "value": 100.0
                },
                {
                    "name": "10/31/2024",
                    "value": 100.0
                },
                {
                    "name": "11/01/2024",
                    "value": 100.0
                },
                {
                    "name": "11/02/2024",
                    "value": 100.0
                }
            ],
            "accountsList": [
                {
                    "accountId": "K75wVdxwqBiMbLMqPQ4lhlnNkXovzxiR1wnje",
                    "mask": "0000",
                    "accountName": null,
                    "nickName": null,
                    "accountType": "depository",
                    "accountSubType": "checking",
                    "accountNumber": "1111222233330000",
                    "routingNumber": "011401533",
                    "title": "Checking",
                    "officialTitle": "Gold Standard 0% Interest Checking",
                    "status": null,
                    "address": null,
                    "availableBalance": 100.0,
                    "currentBalance": 110.0,
                    "currency": "USD",
                    "achAccounts": {
                        "account": null,
                        "accountId": null,
                        "routing": null,
                        "wireRouting": null
                    },
                    "bacAccounts": null,
                    "eftAccounts": null,
                    "createdAt": "2024-10-29T23:24:10.221+00:00",
                    "lastUpdatedAt": "2024-10-31T03:02:14.281+00:00",
                    "dailyBalances": [
                        {
                            "name": "10/29/2024",
                            "value": 100.0
                        },
                        {
                            "name": "10/30/2024",
                            "value": 100.0
                        }
                    ],
                    "international": null
                }
            ],
            "international": null
        },
        {
            "id": "6736972948a6f036c76d2222",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "itemId": "BAPMJR54R1UZjzLlZnVMcplRypgQxPtwAarNo",
            "institutionId": "ins_10",
            "bankProvider": "American Express",
            "integrationProvider": "Plaid",
            "providerAccountId": null,
            "providerId": null,
            "accountId": "jNE9vbgjb1FM7y9VMwzecKre6LP4nwh6arJLn",
            "mask": "3333",
            "accountName": null,
            "nickName": null,
            "accountType": "credit",
            "accountSubType": "credit card",
            "accountNumber": null,
            "routingNumber": null,
            "title": "Credit Card",
            "officialTitle": "Diamond 12.5% APR Interest Credit Card",
            "status": null,
            "address": null,
            "availableBalance": null,
            "currentBalance": 410.0,
            "currency": "USD",
            "achAccounts": null,
            "bacAccounts": null,
            "eftAccounts": null,
            "createdAt": "2024-11-15T00:34:49.326+00:00",
            "lastUpdatedAt": "2024-11-18T01:21:45.891+00:00",
            "dailyBalances": null,
            "accountsList": null,
            "international": null
        },
        {
            "id": "6736972948a6f036c76d2223",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "itemId": "jG4DnE1dMxCW5QaRXgqriDGNrNDKwbu1lR118",
            "institutionId": "ins_10",
            "bankProvider": "Wells Fargo",
            "integrationProvider": "Plaid",
            "providerAccountId": null,
            "providerId": null,
            "accountId": "7mqxopV6pdTQAXvGQDMgCQlAMLRZz7Udx7Xnv",
            "mask": "4444",
            "accountName": null,
            "nickName": null,
            "accountType": "depository",
            "accountSubType": "money market",
            "accountNumber": null,
            "routingNumber": null,
            "title": "Platinum Checking",
            "officialTitle": "Platinum Standard 1.85% Interest Money Market",
            "status": null,
            "address": null,
            "availableBalance": 43200.0,
            "currentBalance": 43200.0,
            "currency": "USD",
            "achAccounts": null,
            "bacAccounts": null,
            "eftAccounts": null,
            "createdAt": "2024-11-15T00:34:49.583+00:00",
            "lastUpdatedAt": "2024-11-18T01:21:45.963+00:00",
            "dailyBalances": null,
            "accountsList": null,
            "international": null
        },
        {
            "id": "6736972948a6f036c76d2224",
            "businessId": "d3d9b17b-5ad1-468c-8ee0-d00ac1a1c088",
            "itemId": "eok4BpA4ootJlgr9Pel3fZe9xrzBRKtLrqpyQ",
            "institutionId": "ins_10",
            "bankProvider": "Chase",
            "integrationProvider": "Plaid",
            "providerAccountId": null,
            "providerId": null,
            "accountId": "e3EGLvJdv7t3P5G13Z8JtwgbP8DRvKtrmoWkW",
            "mask": "9999",
            "accountName": null,
            "nickName": null,
            "accountType": "credit",
            "accountSubType": "credit card",
            "accountNumber": null,
            "routingNumber": null,
            "title": "Business Credit Card",
            "officialTitle": "Platinum Small Business Credit Card",
            "status": null,
            "address": null,
            "availableBalance": 4980.0,
            "currentBalance": 5020.0,
            "currency": "USD",
            "achAccounts": null,
            "bacAccounts": null,
            "eftAccounts": null,
            "createdAt": "2024-11-15T00:34:49.830+00:00",
            "lastUpdatedAt": "2024-11-18T01:21:46.044+00:00",
            "dailyBalances": null,
            "accountsList": null,
            "international": null
        }
    ],
    "transactionsList": null,
    "transactionsCount": 0,
    "transactionsNumPages": 0,
    "result": true,
    "transactionsPageable": false
}